exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toogle-el[data-v-651bd8a3]{\n  display:none;\n}\n.container-align[data-v-651bd8a3] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n", ""]);

// exports
